<template>
    <section class="efficiencyContainer">
        <b-overlay :show="loadingAval" no-wrap></b-overlay>
        <div class="efficiencyForm">
            <CustomInputRta type="select" label="Resp. Verificação de Eficácia" :optList="respList" optValue="id"
                optDisplay="name" :inputFunc="event => { respLocalSelectedId = event.target.value }" />
            <CustomInputRta type="date" :editable="true" label="Data da Verificação" :modelRef="dateAvaliation"
                :inputFunc="event => { dateAvaliation = event.target.value }" />

            <div v-if="filesUploaded == false">
                <button type="button" @click="triggerFileInput">
                    <b-icon-paperclip />
                    <span>Anexar Evidências</span>
                </button>
                <input type="file" ref="fileInput" multiple :accept="allowedFileTypes" style="display: none;"
                    @change="onFileChange" />
            </div>
            <div v-else>
                <button type="button" @click="downloadFile" class="downloadBtn">
                    <span class="downloadCount">
                        {{ Array.isArray(filesToUpload) ? filesToUpload.length : 1 }}
                    </span>
                    <b-icon-download />
                    <span>Baixar Evidências</span>
                </button>
            </div>
        </div>

        <div>
            <div>
                <b-form-checkbox v-model="indicatorInLimits">
                    O indicador ou parâmetro ficou dentro do previsto após a finalização das ações
                </b-form-checkbox>
                <b-form-checkbox v-model="reasonDealed">
                    A causa raiz do problema foi identificada e tratada
                </b-form-checkbox>
            </div>
        </div>
        <div class="observationArea">
            <label for="observation">Observações</label>
            <b-form-textarea id="observation" :v-model="observationTxt" :value="observationTxt"
                @input="(e) => observationTxt = e.target.value"></b-form-textarea>
        </div>

        <div class="efficiencyBtn">
            <button>Cancelar</button>
            <div v-if="approveMsg == null">
                <button @click="() => avaliateRta(false)">Reprovar</button>
                <button @click="() => avaliateRta(true)">Aprovar</button>
            </div>
            <div v-else :class="approveMsg == 'Eficaz' ? 'eficClass' : 'ineficClass'">
                <p>Status: <span>{{ approveMsg }}</span></p>
            </div>
        </div>
    </section>
</template>

<script>
import CustomInputRta from './CustomInputRta.vue';
import * as moment from 'moment';
import JSZip from "jszip";
import axios from '../../../../node_modules/axios/index';
import { defaultSuccess, showError, urlMainAPI } from '../../../global';
export default {
    name: "EfficiencyForm",
    props: ["evidenceIsRequired", "respList", "detailsRta", "efficrelatedid", "effitCtype"],
    components: { CustomInputRta },
    data() {
        return {
            reasonDealed: false,
            indicatorInLimits: false,
            respLocalSelectedId: 0,
            dateAvaliation: moment().format('yyyy-MM-DD'),
            filesToUpload: [],
            filesUploaded: false,
            allowedFileTypes: '.png,.jpg,.jpeg,.pdf,.doc,.docx',
            maxTotalSizeMB: 25,
            isNew: true,
            efficLoad: null,
            observationTxt: "",
            efficStatus: null,
            loadingAval: false,
            approveMsg: null
        }
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        onFileChange(event) {
            const files = Array.from(event.target.files);

            const totalSizeBytes = files.reduce((total, file) => total + file.size, 0);
            const totalSizeMB = totalSizeBytes / (1024 * 1024);

            if (totalSizeMB > this.maxTotalSizeMB) {
                this.$bvToast.toast(
                    `O tamanho total dos arquivos selecionados (${totalSizeMB.toFixed(2)} MB) excede o limite de ${this.maxTotalSizeMB} MB.`,
                    {
                        title: "Arquivos muito grandes!",
                        variant: "warning",
                        toaster: 'b-toaster-bottom-left',
                        solid: true
                    }
                );
                this.$refs.fileInput.value = "";
                return;
            }
            this.filesToUpload = [];

            this.readFiles(files)
                .then(fileDataArray => {
                    this.filesToUpload = fileDataArray;
                    if (this.filesToUpload.length > 0) this.filesUploaded = true;
                })
                .catch(error => {
                    this.$bvToast.toast(`Falha ao ler arquivos.`, {
                        title: "Arquivo inválido!",
                        variant: "warning",
                        toaster: 'b-toaster-bottom-left',
                        solid: true
                    });
                    console.error(error);
                });

            if (files.length > 0) this.filesUploaded = true;
        },

        readFiles(files) {
            const promises = files.map(file => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        resolve({
                            name: file.name,
                            type: file.type,
                            size: file.size,
                            data: e.target.result
                        });
                    };
                    reader.onerror = (error) => {
                        reject(error);
                    };
                    reader.readAsDataURL(file);
                });
            });
            return Promise.all(promises);
        },

        async createZipBase64() {
            const zip = new JSZip();
            this.filesToUpload.forEach(file => {
                const base64Data = file.data.split(',')[1];
                zip.file(file.name, base64Data, { base64: true });
            });
            const base64Zip = await zip.generateAsync({ type: "base64" });
            return base64Zip;
        },

        async avaliateRta(status) {
            if (this.evidenceIsRequired && this.evidenceIsRequired == true) {
                if ((Array.isArray(this.filesToUpload) && this.filesToUpload.length == 0) || (!Array.isArray(this.filesToUpload) && !this.filesToUpload.blob)) {
                    this.$bvToast.toast(`As evidências são obrigatórias para concluir a avaliação!`, {
                        title: "Evidências Obrigatórias.",
                        variant: "warning",
                        toaster: 'b-toaster-bottom-left',
                        solid: true
                    });
                    return;
                }
            }
            this.loadingAval = true;

            this.efficStatus = status;

            let type = this.effitCtype == 'action' ? 0 : 1;

            let objToSend = {
                id: this.efficLoad ? this.efficLoad.id : -9999,
                rtaId: this.efficLoad ? this.efficLoad.rtaId : this.detailsRta.id,
                efficiencyType: this.efficLoad ? this.efficLoad.efficiencyType : type,
                actionId: this.efficLoad ? this.efficLoad.actionId : this.efficrelatedid.toString(),
                analysisId: this.efficLoad ? this.efficLoad.analysisId : Number(this.efficrelatedid),
                responsibleId: Number(this.respLocalSelectedId),
                efficiencyDate: this.dateAvaliation,
                efficiencyReport: this.observationTxt,
                indicatorBackToLimit: this.indicatorInLimits,
                rootReasonSolved: this.reasonDealed,
                approveEfficiency: this.efficStatus,
                appendedFileId: this.efficLoad ? this.efficLoad.appendedFileId : -9999,
            };

            let filesToSend = null;
            if (Array.isArray(this.filesToUpload) && this.filesToUpload.length > 0) {
                const zipBase64 = await this.createZipBase64();
                filesToSend = { id: this.efficLoad ? this.efficLoad.appendedFileId : -9999, blob: zipBase64 };
            }
            else if (this.filesToUpload && this.filesToUpload.blob) {
                filesToSend = this.filesToUpload;
            }

            await axios.post(`${urlMainAPI}/saveefficiencyrta`, {
                efficiency: objToSend,
                files: filesToSend
            }).then(() => {
                this.approveMsg = this.efficStatus == true ? "Aprovado" : "Reprovado"
                defaultSuccess("Avaliação armazenada com sucesso!");
            }).catch(err => {
                console.error(err)
                showError("Falha ao armazenar avaliação!");
            });
            

            this.loadingAval = false;
        },

        downloadFile() {
            if (Array.isArray(this.filesToUpload)) {
                const zip = new JSZip();
                this.filesToUpload.forEach(file => {
                    const base64Data = file.data.split(',')[1];
                    zip.file(file.name, base64Data, { base64: true });
                });
                zip.generateAsync({ type: "blob" })
                    .then(content => {
                        const url = URL.createObjectURL(content);
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = "arquivos.zip";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                    })
                    .catch(err => {
                        console.error("Erro ao gerar ZIP:", err);
                    });
            }
            else if (this.filesToUpload && this.filesToUpload.blob) {
                const byteCharacters = atob(this.filesToUpload.blob);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/zip' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = "arquivos.zip";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        },

        async loadEfficiency() {
            this.loadingAval = true;
            await axios.get(
                `${urlMainAPI}/getefficiencyrta/${this.detailsRta.id}/${this.effitCtype}/${this.efficrelatedid}`
            ).then(res => {
                if (res.data != null) {
                    this.efficLoad = res.data.effic;
                    if (res.data.files) {
                        this.filesToUpload = res.data.files;
                    }

                    defaultSuccess('Avaliação Carregada.')
                }
            }).catch(err => {
                console.error(err);
                showError('Falha ao carregar avaliação.')
            });

            this.loadingAval = false;
        }
    },
    async mounted() {
        this.loadingAval = true;

        this.respLocalSelectedId = this.detailsRta.efficiencyRespId;

        await this.loadEfficiency();

        if (this.efficLoad) {
            this.respLocalSelectedId = this.efficLoad.responsibleId;
            this.dateAvaliation = this.efficLoad.efficiencyDate;
            this.observationTxt = this.efficLoad.efficiencyReport;
            this.indicatorInLimits = this.efficLoad.indicatorBackToLimit;
            this.reasonDealed = this.efficLoad.rootReasonSolved;
            this.efficStatus = this.efficLoad.approveEfficiency;

            this.approveMsg = this.efficStatus == true ? "Eficaz" : "Ineficaz"
        }

        if (
            (Array.isArray(this.filesToUpload) && this.filesToUpload.length > 0) ||
            (!Array.isArray(this.filesToUpload) && this.filesToUpload.blob)
        ) {
            this.filesUploaded = true;
        }

        this.loadingAval = false;
    },
}
</script>

<style scoped>
.efficiencyForm {
    display: flex;
    align-items: flex-start;
    column-gap: 1rem;
    margin-bottom: 0.8rem;
}

.efficiencyForm button {
    width: max-content;
    white-space: nowrap;
    background-color: #ff5f00;
    color: #fff;
    border: 1px solid #ff5f00;
    border-radius: 0.2rem;
    padding: 0.4rem;
    font-weight: 600;
}

.observationArea {
    margin-top: 1.5rem;
    border: 1px solid #C7C7C7 !important;
    border-radius: 0.2rem;
    position: relative;
}

.observationArea label {
    position: absolute;
    top: -0.8rem;
    left: 0.4rem;
    background-color: white;
    font-size: 0.8rem;
    color: #FF5F00;
    padding-left: 0.3rem;
    padding-right: 0.5rem;
    font-weight: 500;
}

.observationArea textarea {
    border: none !important;
}

.efficiencyBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.8rem;
}

.efficiencyBtn button {
    padding: 0.5rem 0.8rem;
    font-weight: 500;
    color: #D21724;
    background-color: white;
    border-radius: 0.2rem;
    border: 1px solid #D21724;
}

.efficiencyBtn div button:first-child {
    background-color: white;
    color: #008787;
    margin-right: 0.8rem;
    border-color: #008787;
}

.efficiencyBtn div button:last-child {
    background-color: #008787;
    color: white;
    border-color: #008787;
}

.downloadBtn {
    position: relative;
    background-color: #f8e4d9 !important;
    border-color: #f8e4d9 !important;
    color: #FF5F00 !important;
}

.downloadBtn span {
    margin-left: 0.2rem;
}

.downloadCount {
    position: absolute;
    top: -5px;
    right: -5px;
    border-radius: 100%;
    padding: 0 0.3rem;
    background-color: #FF5F00;
    border: 2px solid white;
    color: #fff;
    font-size: 0.7rem;
}

.eficClass {
    color: #008787;
}

.ineficClass {
    color: #ff2323;
}

.ineficClass p span,
.eficClass p span {
    font-weight: bold;
    font-size: 1.2rem;
}
</style>